<template>
  <div>
    <div class="layout">
      <div class="section">
        <div class="title">Wat zegt uw inkomstenbron over uw lening?</div>

        <div class="expandable-items">
          <div class="exp-item">
            <div class="exp-item-title" v-expand>
              <div class="left">Heeft u (of uw partner) een negatieve BKR-registratie?</div>

              <div class="right">
                <div class="arrow"></div>
              </div>
            </div>

            <div class="exp-item-text">

              <div class="exp-item-body">
                Heeft u (of uw partner) een negatieve BKR registratie en u wilt graag geld lenen?
                Bij Leenattent is dat in vele gevallen wel mogelijk!
              </div>

              <router-link to="/ik-heb-een-negatieve-bkr-registratie">
                <btn-big class="secondary-pink" :width="231" :height="74">
                  <div class="content">
                    <div class="txt">Lees meer</div>
                    <img src="@/assets/arrow.svg" alt />
                  </div>
                </btn-big>
              </router-link>
            </div>
          </div>

          <div class="exp-item">
            <div class="exp-item-title" v-expand>
              <div class="left">Bent u (of uw partner) zelfstandige?</div>

              <div class="right">
                <div class="arrow"></div>
              </div>
            </div>

            <div class="exp-item-text">
              <div class="exp-item-body">
                Bent u (of uw partner) zelfstandig ondernemer en u wilt geld lenen?
                Bij Leenattent kunt U als zelfstandig ondernemer voor meerdere doelen geld lenen.
              </div>
              <router-link to="/ik-ben-zelfstandige">
                <btn-big class="secondary-pink" :width="231" :height="74">
                  <div class="content">
                    <div class="txt">Lees meer</div>
                    <img src="@/assets/arrow.svg" alt />
                  </div>
                </btn-big>
              </router-link>
            </div>

          </div>

          <div class="exp-item">
            <div class="exp-item-title" v-expand>
              <div class="left">Heeft u (of uw partner) een tijdelijk dienstverband?</div>

              <div class="right">
                <div class="arrow"></div>
              </div>
            </div>

            <div class="exp-item-text">
              <div class="exp-item-body">
                Heeft u (of uw partner) een tijdelijk dienstverband en u wilt geld lenen?
                Bij Leenattent is dat zeker mogelijk!
              </div>
              <router-link to="/ik-heb-een-tijdelijk-dienstverband">
                <btn-big class="secondary-pink" :width="231" :height="74">
                  <div class="content">
                    <div class="txt">Lees meer</div>
                    <img src="@/assets/arrow.svg" alt />
                  </div>
                </btn-big>
              </router-link>
            </div>

          </div>

          <div class="exp-item">
            <div class="exp-item-title" v-expand>
              <div class="left">Bent u (of uw partner) werkzaam via een uitzendbureau?</div>

              <div class="right">
                <div class="arrow"></div>
              </div>
            </div>

            <div class="exp-item-text">
              <div class="exp-item-body">
                Bent u (of uw partner) werkzaam via een uitzendbureau en u wilt geld lenen?
                Bij Leenattent is dat in vele gevallen mogelijk!
              </div>
              <router-link to="/ik-werk-via-een-uitzendbureau">
                <btn-big class="secondary-pink" :width="231" :height="74">
                  <div class="content">
                    <div class="txt">Lees meer</div>
                    <img src="@/assets/arrow.svg" alt />
                  </div>
                </btn-big>
              </router-link>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.area {
  background-color: getColor("greyLight");

  .layout {
    align-items: center;

    .section {
      text-align: left;
      justify-content: center;
      display: flex;
      flex-direction: column;
      margin-bottom: pxToEm(110);
      width: pxToEm(992);

      @media (max-width: 1000px) {
        width: initial;
        //margin: 0 pxToEm(50);
      }

      .title {
        font-size: pxToEm(36);
        margin: pxToEm(55) 0 pxToEm(15) 0;

        @media (max-width: 768px) {
          font-size: pxToEm(24);
          line-height: pxToEm(16);
          text-decoration: underline;
          font-weight: 700;
          margin-top: pxToEm(60);
          margin-bottom: pxToEm(10);
        }
      }

      .expandable-items {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;

        .exp-item {
          height: pxToEm(125);
          overflow: hidden;
          max-width: pxToEm(992);
          background-color: #fff;
          padding: 0 0 0 pxToEm(50);
          margin-bottom: pxToEm(50);
          box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);

          @media (max-width: 768px) {
            padding: 0 0 0 pxToEm(10);
            height: pxToEm(94);
            margin-bottom: pxToEm(30);
          }

          a {
            text-decoration: none;
          }

          .btn-big {
            margin: 50px 0;

            .content {
              margin: 0 20px;

              .txt {
                font-size: pxToPercent(18);
                font-weight: 800;
              }

              img {
                width: pxToEm(36);
                height: pxToEm(29);
              }
            }
          }

          &.expanded {
            height: auto;

            .exp-item-title .arrow {
              transform: rotate(-135deg);
            }
          }

          &:last-child {
            @media (min-width: 1000px) {
              margin: 0;
            }
          }

          .exp-item-title {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: pxToEm(125);
            cursor: pointer;

            @media (max-width: 768px) {
              height: pxToEm(94);
            }

            .left {
              flex: 2 1 auto;

              font-size: pxToEm(24);

              @media (max-width: 768px) {
                font-size: pxToEm(18);
                font-weight: 600;
              }
            }

            .right {
              width: pxToEm(100);
              height: pxToEm(100);
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .arrow {
              border: solid black;
              border-width: 0 2px 2px 0;
              display: inline-block;
              padding: 5px;
              transform: rotate(45deg);
              position: relative;
            }
          }

          .exp-item-text {
            max-width: 768px;

            .exp-item-body {
              font-size: pxToPercent(18);
              line-height: 2.2em;

              @media (max-width: 768px) {
                font-size: pxToPercent(16);
              }
            }

            &:last-child {
              margin-bottom: pxToEm(50);
            }

            .exp-item-subtitle {
              font-weight: 700;
            }
          }
        }
      }
    }
  }
}
</style>

<script>
import btnBig from "@/components/common/btn-big";

export default {
  name: "loanInfo",
  components: {
    btnBig
  }
};
</script>
